import { Component, Input } from '@angular/core';

import { IconPosition } from '../../new-button.component';

@Component({
  selector: 'broker-button-info-svg',
  templateUrl: './info.component.svg'
})
export class InfoSvgComponent {
  @Input() position: IconPosition = 'right';
}
